// extracted by mini-css-extract-plugin
export default {"floatAd":"index_floatAd_db7qt"};